<div class="pt-3">
    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">rule</mat-icon>
            <span>Tributação</span>
            <div class="section-title-actions ms-auto">
                <button mat-button class="btn-section" type="button" (click)="editarEtapa.emit(0)">
                    <mat-icon>edit</mat-icon>
                    Editar
                </button>
            </div>
        </div>

        <div class="resumo-topicos">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon class="material-symbols-outlined">description</mat-icon>
                    <span>Modelos de documento</span>
                </div>
                <div class="resumo-badges">
                    @for (modelo of modelosSelecionados; track modelo) {
                    <span class="status-badge badge-azul">{{ modelo }}</span>
                    } @empty {
                    <span class="text-secondary small">Nenhum modelo selecionado</span>
                    }
                </div>
            </div>

            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
                    <span>CST IBS/CBS</span>
                </div>
                <div class="resumo-badges">
                    @if (temCst) {
                    <span class="status-badge badge-cinza badge-wrap">{{ cstDescricao }}</span>
                    } @else {
                    <span class="text-secondary small">Não informado</span>
                    }
                </div>
            </div>

            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon class="material-symbols-outlined">qr_code</mat-icon>
                    <span>Cod. Classificação Trib. IBS/CBS</span>
                </div>
                <div class="resumo-badges">
                    @if (temCclass) {
                    <span class="status-badge badge-cinza badge-wrap">{{ cclassDescricao }}</span>
                    } @else {
                    <span class="text-secondary small">Não informado</span>
                    }
                </div>
            </div>

            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
                    <span>Grupos de tributação</span>
                </div>
                <div class="resumo-badges">
                    @for (grupo of gruposTributacaoAtivos; track grupo) {
                    <span class="status-badge badge-azul">{{ grupo }}</span>
                    } @empty {
                    <span class="text-secondary small">Nenhum grupo tributário ativo.</span>
                    }
                </div>
            </div>

            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon class="material-symbols-outlined">notes</mat-icon>
                    <span>Informações complementares</span>
                </div>
                @if (formValue.observacao) {
                <p class="resumo-texto">{{ formValue.observacao }}</p>
                } @else {
                <span class="text-secondary small">Não informadas</span>
                }
            </div>

            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
                    <span>Informações adicionais ao fisco</span>
                </div>
                @if (formValue.informacaoFisco) {
                <p class="resumo-texto">{{ formValue.informacaoFisco }}</p>
                } @else {
                <span class="text-secondary small">Não informadas</span>
                }
            </div>
        </div>
    </div>

    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">person_search</mat-icon>
            <span>Escopo</span>
            <div class="section-title-actions ms-auto">
                <button mat-button class="btn-section" type="button" (click)="editarEtapa.emit(1)">
                    <mat-icon>edit</mat-icon>
                    Editar
                </button>
            </div>
        </div>

        <div class="sub-section-container">
            <div class="sub-section-title">
                <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
                <span>Produto</span>
            </div>
            <div class="sub-section-2-container">
                <div class="sub-section-2-title">
                    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
                    <span>Produto</span>
                </div>
                <div class="resumo-badges">
                    @for (produto of escopoValue.produtos; track produto.codigo) {
                    <span class="status-badge badge-cinza">{{ badgeLabel(produto) }}</span>
                    } @empty {
                    <app-empty-state icon="inventory_2" title="Nenhum produto adicionado" subtitle="A regra vale para qualquer produto."></app-empty-state>
                    }
                </div>
            </div>
            <div class="sub-section-2-container">
                <div class="sub-section-2-title">
                    <mat-icon class="material-symbols-outlined">category</mat-icon>
                    <span>NCM</span>
                </div>
                <div class="resumo-badges">
                    @for (ncm of escopoValue.ncms; track ncm) {
                    <span class="status-badge badge-cinza">{{ formatNcm(ncm) }}</span>
                    } @empty {
                    <app-empty-state icon="category" title="Nenhum NCM adicionado" subtitle="A regra vale para qualquer NCM."></app-empty-state>
                    }
                </div>
            </div>
        </div>

        <div class="sub-section-container">
            <div class="sub-section-title">
                <mat-icon class="material-symbols-outlined">person_search</mat-icon>
                <span>Cliente</span>
            </div>
            <div class="sub-section-2-container">
                <div class="sub-section-2-title">
                    <mat-icon class="material-symbols-outlined">person_search</mat-icon>
                    <span>Contribuinte de IBS/CBS</span>
                </div>
                <div class="resumo-badges">
                    @for (id of escopoValue.contribIbsCbs; track id) { <span class="status-badge badge-cinza">{{ labelContrib(id) }}</span> } @empty {
                    <app-empty-state icon="person_search" title="Nenhum contribuinte de IBS/CBS selecionado" subtitle="A regra vale para qualquer cliente neste critério."></app-empty-state>
                    }
                </div>
            </div>
            <div class="sub-section-2-container">
                <div class="sub-section-2-title">
                    <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
                    <span>Regime Tributário</span>
                </div>
                <div class="resumo-badges">
                    @for (id of escopoValue.regimesTrib; track id) { <span class="status-badge badge-cinza">{{ labelLookup(id, listaRegimeTributario) }}</span> } @empty {
                    <app-empty-state icon="account_balance" title="Nenhum regime tributário selecionado" subtitle="A regra vale para qualquer cliente neste critério."></app-empty-state>
                    }
                </div>
            </div>
            <div class="sub-section-2-container">
                <div class="sub-section-2-title">
                    <mat-icon class="material-symbols-outlined">badge</mat-icon>
                    <span>Tipo Tributário</span>
                </div>
                <div class="resumo-badges">
                    @for (id of escopoValue.tiposTrib; track id) { <span class="status-badge badge-cinza">{{ labelLookup(id, listaTipoTributario) }}</span> } @empty {
                    <app-empty-state icon="badge" title="Nenhum tipo tributário selecionado" subtitle="A regra vale para qualquer cliente neste critério."></app-empty-state>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
            <span>Naturezas</span>
            <div class="section-title-actions ms-auto">
                <button mat-button class="btn-section" type="button" (click)="editarEtapa.emit(2)">
                    <mat-icon>edit</mat-icon>
                    Editar
                </button>
            </div>
        </div>

        <div class="resumo-lista">
            @for (natureza of naturezasSelecionadas; track natureza.idNaturezaOperacao) {
            <div class="resumo-lista-item">
                <strong>{{ natureza.nome }}</strong>
                <span class="status-badge badge-cinza">{{ natureza.cfopPadrao | mask: '0.000' : { patterns: cfopMaskPatterns } }}</span>
                <span class="status-badge"
                    [class.badge-azul]="natureza.idTipoOperacao === TipoOperacaoEnum.Entrada"
                    [class.badge-laranja]="natureza.idTipoOperacao === TipoOperacaoEnum.Saida">
                    {{ tipoOperacaoLabel[natureza.idTipoOperacao] || natureza.idTipoOperacao }}
                </span>
            </div>
            } @empty {
            <app-empty-state
                icon="receipt_long"
                title="Nenhuma natureza de operação vinculada"
                subtitle="A regra será aplicada a todas as operações que corresponderem ao escopo configurado.">
            </app-empty-state>
            }
        </div>
    </div>
</div>
